/**
 * SOONJ-2049: no subsolo o operador escolhe se o reboque sobe junto.
 *
 * A ausência de `subsoloComReboque` equivale a `true`: estados antigos e telas que não
 * oferecem a escolha continuam abrindo o par, como sempre foi.
 */
const subsoloAbreReboque = (service) => service.subsoloComReboque !== false;

/** Subsolo aberto sozinho: uma solicitação só, sem trajeto e sem destino. */
export const isSubsoloSemReboque = (service) =>
  service.tipoServico === 'SUBSOLO' && !subsoloAbreReboque(service);

export const isTwoRouteService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  if (isSubsoloSemReboque(service)) {
    return false;
  }

  return service.tipoServico === `REBOQUE` || service.tipoServico === 'SUBSOLO';
};

export const isThreeRouteService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  return service.tipoServico === `LEVAETRAZ`;
};

export const isTwoSolicitationService = (service) => {
  if (service.tipoServico === null || service.tipoServico === undefined) {
    throw new Error('Tipo serviço null ou undefined');
  }

  if (isSubsoloSemReboque(service)) {
    return false;
  }

  return service.tipoServico === `LEVAETRAZ` || service.tipoServico === 'SUBSOLO';
};

/** Serviços que exigem endereço de destino ao criar a solicitação. */
export const SERVICES_NEEDING_DESTINY = [
  'REBOQUE',
  'SUBSOLO',
  'LEVAETRAZ',
  'TAXI',
  'PANESECA',
];

/**
 * Indica se o serviço exige endereço de destino.
 *
 * Diferente de `isTwoRouteService`/`isThreeRouteService`, recebe o código do serviço e
 * devolve `false` quando ele ainda não foi escolhido — é usado em telas onde o operador
 * seleciona o serviço depois de abrir o formulário.
 */
export const serviceNeedsDestiny = (tipoServico) =>
  SERVICES_NEEDING_DESTINY.includes(tipoServico);

/**
 * Igual a `serviceNeedsDestiny`, mas considerando a escolha de abrir o reboque junto do
 * subsolo (SOONJ-2049).
 *
 * A solicitação de subsolo sempre nasceu sem destino — ela cobre só a retirada do veículo
 * da garagem, e quem percorre o trajeto é o reboque. Sem o reboque, pedir o endereço de
 * destino ao operador vira um bloqueio sem motivo.
 */
export const solicitationNeedsDestiny = (tipoServico, subsoloComReboque) =>
  !isSubsoloSemReboque({tipoServico, subsoloComReboque}) &&
  serviceNeedsDestiny(tipoServico);
